import InfoTip from "./InfoTip";
import Spark from "./Spark";
import { money, signed, pct, dpct, dpts, COLORS } from "./metricsMath";

const tone = (v, upGood = true) => (v == null || v === 0 ? "" : (upGood ? v > 0 : v < 0) ? "text-[#00873D]" : "text-[#E0000F]");

function Kpi({ label, help, big, bigClass = "", sub, children, testid }) {
  return (
    <div className="border border-zinc-200 bg-white rounded-lg p-4 flex flex-col gap-1 min-w-0 justify-between" data-testid={testid}>
      <span className="text-xs text-zinc-500 inline-flex items-center gap-1.5">{label} <InfoTip k={help} /></span>
      <span className={`font-heading text-2xl font-extrabold numeric leading-tight truncate ${bigClass}`} data-testid={`${testid}-value`}>{big}</span>
      <span className="text-xs text-zinc-500 numeric">{sub}</span>
      {children}
    </div>
  );
}

// 5 KPIs del año con comparación contra el mes anterior y mini tendencia.
export default function KpiCards({ rows, t, year }) {
  const vs = t.mesAnterior ? ` vs ${t.mesAnterior}` : "";
  return (
    <section className="grid grid-cols-2 lg:grid-cols-3 min-[1440px]:grid-cols-5 gap-3" data-testid="metrics-kpis">
      <Kpi testid="kpi-inflow" label={`Entró al banco · ${year}`} help="inflow" big={money(t.entro)} bigClass="text-[#00873D]"
        sub={<>{t.mes}: <b className="text-zinc-900">{money(t.ultimoEntro)}</b>{t.entroDelta != null && <> · <b className={tone(t.entroDelta)}>{dpct(t.entroDelta)}</b>{vs}</>}</>}>
        <Spark rows={rows} k="entro" color={COLORS.in} testid="spark-inflow" />
      </Kpi>
      <Kpi testid="kpi-outflow" label={`Salió del banco · ${year}`} help="outflow" big={money(t.salio)} bigClass="text-[#E0000F]"
        sub={<>{t.mes}: <b className="text-zinc-900">{money(t.ultimoSalio)}</b>{t.salioDelta != null && <> · <b className={tone(t.salioDelta, false)}>{dpct(t.salioDelta)}</b>{vs}</>}</>}>
        <Spark rows={rows} k="salio" color={COLORS.out} testid="spark-outflow" />
      </Kpi>
      <Kpi testid="kpi-net" label="Neto del año" help="net" big={signed(t.neto)} bigClass={tone(t.neto) || "text-zinc-900"}
        sub={<>{t.mes}: <b className={tone(t.ultimoNeto) || "text-zinc-900"}>{signed(t.ultimoNeto)}</b> · meses en rojo: <b className="text-zinc-900">{t.mesesNegativos}</b></>}>
        <Spark rows={rows} k="neto" kind="net" testid="spark-net" />
      </Kpi>
      <Kpi testid="kpi-balance" label="Saldo actual en bancos" help="balance" big={money(t.saldo)} bigClass="text-[#002FA7]"
        sub={<>Cierre de {t.mes}{t.saldoDelta != null && <> · <b className={tone(t.saldoDelta)}>{dpct(t.saldoDelta)}</b>{vs}</>}</>}>
        <Spark rows={rows} k="saldo" kind="line" testid="spark-balance" />
      </Kpi>
      <Kpi testid="kpi-ratio" label={`Gastos / entradas · ${year}`} help="ratio" big={pct(t.ratio)} bigClass={t.ratio == null ? "text-zinc-400" : t.ratio > 1 ? "text-[#E0000F]" : t.ratio > 0.7 ? "text-amber-600" : "text-zinc-900"}
        sub={<>{t.mes}: <b className="text-zinc-900">{pct(t.ultimoRatio)}</b>{t.ratioDeltaPts != null && <> · <b className={tone(t.ratioDeltaPts, false)}>{dpts(t.ratioDeltaPts)}</b>{vs}</>}</>}>
        <Spark rows={rows} k="ratio" color={COLORS.gas} testid="spark-ratio" />
      </Kpi>
    </section>
  );
}
